import React from "react";

// Bespoke line art per vehicle type. PLACEHOLDER for real fleet photography.
// `type` maps to a key in data/fleet.js.
const artStroke = { fill: "none", stroke: "currentColor", strokeWidth: 2.4, strokeLinejoin: "round", strokeLinecap: "round" };
const Wheel = ({ cx }) => (
  <g><circle cx={cx} cy="110" r="13" {...artStroke} /><circle cx={cx} cy="110" r="4.6" {...artStroke} strokeWidth="2" /></g>
);

const VehicleArt = ({ type, label }) => {
  const glass = { fill: "#ECEEFC", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" };
  const bodies = {
    artic: (
      <g>
        <path d="M152 32h236v74H152z" {...artStroke} />
        <path d="M152 62h236" {...artStroke} strokeWidth="1.4" opacity=".45" />
        <path d="M40 106V72l16-30h56v64z" {...artStroke} />
        <path d="M112 106h40" {...artStroke} />
        <path d="M62 48h44v20H50z" {...glass} />
        <path d="M40 84h10" {...artStroke} strokeWidth="2" />
        <Wheel cx="72" /><Wheel cx="176" /><Wheel cx="336" /><Wheel cx="372" />
      </g>
    ),
    rigid: (
      <g>
        <path d="M148 40h214v66H148z" {...artStroke} />
        <path d="M148 40v66" {...artStroke} strokeWidth="1.4" opacity=".45" />
        <path d="M62 106V74l16-28h70v60z" {...artStroke} />
        <path d="M84 52h60v20H70z" {...glass} />
        <path d="M62 86h10" {...artStroke} strokeWidth="2" />
        <Wheel cx="98" /><Wheel cx="308" />
      </g>
    ),
    van: (
      <g>
        <path d="M74 106V72l30-26h150c7 0 12 5 12 12v48z" {...artStroke} />
        <path d="M110 52h48v22h-46z" {...glass} />
        <path d="M170 52h44v22h-44z" {...glass} />
        <path d="M232 60h32" {...artStroke} strokeWidth="1.6" opacity=".5" />
        <path d="M74 88h12" {...artStroke} strokeWidth="2" />
        <Wheel cx="118" /><Wheel cx="232" />
      </g>
    ),
    evan: (
      <g>
        <path d="M74 106V72l30-26h150c7 0 12 5 12 12v48z" {...artStroke} />
        <path d="M110 52h48v22h-46z" {...glass} />
        <path d="M170 52h44v22h-44z" {...glass} />
        <path d="M74 88h12" {...artStroke} strokeWidth="2" />
        <path d="M244 74l-11 14h9l-3 12 12-15h-9z" fill="#5A63D8" stroke="none" />
        <circle cx="96" cy="66" r="9" {...artStroke} strokeWidth="1.8" />
        <path d="M96 61.5v9M91.5 66h9" {...artStroke} strokeWidth="1.8" />
        <Wheel cx="118" /><Wheel cx="232" />
      </g>
    ),
  };
  return (
    <svg viewBox="0 0 420 140" width="100%" role="img" aria-label={label}>
      <g>{bodies[type]}</g>
      <path d="M14 128h392" stroke="currentColor" strokeWidth="1.6" opacity=".25" strokeLinecap="round" />
      <path d="M14 128h70" stroke="#5A63D8" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
};

export default VehicleArt;
